module.exports = __webpack_public_path__ + "static/pic03@3x-0b6ccb544ec7724e1f27e55937cfa37f.jpg";